import { render, staticRenderFns } from "./CheckoutErrorBlock.vue?vue&type=template&id=36492a89&lang=pug&"
import script from "./CheckoutErrorBlock.vue?vue&type=script&lang=js&"
export * from "./CheckoutErrorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports